import { House } from "../../svg/House";
import { NewRequest } from "../../svg/NewRequest";
import { Requests } from "../../svg/Requests";

export const links = [
  {
    tooltipTitle: "tooltips.home",
    destination: "/",
    logo: {
      Component: House,
      color: "#000032",
      fillColor: "#3948FF",
      size: "1.625em",
    },
  },
  {
    tooltipTitle: "tooltips.request",
    destination: "/request/all",
    logo: {
      Component: Requests,
      color: "#000032",
      fillColor: "#3948FF",
      size: "1.625em",
    },
  },
  {
    tooltipTitle: "tooltips.createRequest",
    destination: "/request/new",
    logo: {
      Component: NewRequest,
      color: "#000032",
      fillColor: "#3948FF",
      size: "1.625em",
    },
  },
];
